import { Theme } from "@bluframe/blublocks"
import Typography from "components/Typography"
import styled from "styled-components"
import mediaQueries from "styles/mediaQueries"

export const Form = styled.form`
  align-items: start;
  background: ${({ theme }: { theme: Theme }) => theme.palette.text.contrast};
  display: grid;
  padding: 20px;
  row-gap: 20px;
  width: 100%;
`

export const Actions = styled.div`
  background: ${({ theme }: { theme: Theme }) => theme.palette.text.contrast};
  column-gap: 8px;
  display: grid;
  grid-template-columns: auto auto;
  row-gap: 20px;

  & > div {
    grid-column: span 2;
  }
`

export const Top = styled.div`
  align-items: start;
  column-gap: 40px;
  display: grid;
  grid-template-columns: 1fr 200px;

  ${mediaQueries.desktop} {
    grid-template-columns: 1fr 300px;
  }

  ${mediaQueries.largeDesktop} {
    grid-template-columns: 1fr 400px;
  }
`

export const NameAndInfo = styled.div<{ $isEditMode: boolean }>`
  display: grid;
  row-gap: ${({ $isEditMode }) => ($isEditMode ? "32px" : "10px")};
`

export const Info = styled(Typography.Paragraph)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.subtitle.main};
`

export const Main = styled.div`
  display: grid;
  row-gap: 20px;
`

export const Images = styled.div`
  display: grid;
  row-gap: 20px;

  & ul[aria-label="Images Carousel List"],
  ul[aria-label="Images Editing Carousel List"] {
    max-height: 250px;
  }
`

export const InputAndButton = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto;
`

export const Image = styled.img``
